import { useMediaQuery } from '@/shared/hooks/useMediaQuery';
import { MOBILE_QUERY, type Device } from './device';

/** The device the page is being shown on right now, live as the window resizes. */
export function useDevice(): Device {
  return useMediaQuery(MOBILE_QUERY) ? 'mobile' : 'desktop';
}
